import { SVGProps } from "react"

interface DestinationIconProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const DestinationIcon = (props: DestinationIconProps) => (
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.333374"
      width="50"
      height="50"
      rx="25"
      fill={props.isActive ? "#2768A3" : "#ABB7C2"}
      fill-opacity={props.isActive ? "1" : "0.1"}
    />
    <path
      d="M14.3334 35H36.3334"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.1134 35.0108V30.5508"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.1334 23.8906C31.9134 23.8906 30.9333 24.8706 30.9333 26.0906V28.3606C30.9333 29.5806 31.9134 30.5606 33.1334 30.5606C34.3534 30.5606 35.3334 29.5806 35.3334 28.3606V26.0906C35.3334 24.8706 34.3534 23.8906 33.1334 23.8906Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4333 35.0017V19.0317C15.4333 17.0217 16.4334 16.0117 18.4234 16.0117H24.6534C26.6434 16.0117 27.6334 17.0217 27.6334 19.0317V35.0017"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1334 21.25H24.0834"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1334 25H24.0834"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5834 35V31.25"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default DestinationIcon
